import { render, staticRenderFns } from "./Carte.vue?vue&type=template&id=992a553a&"
import script from "./Carte.vue?vue&type=script&lang=js&"
export * from "./Carte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports